import { Image, ProgressBar } from 'react-bootstrap'
import { FaCheckCircle } from 'react-icons/fa'
import dataTabLesson from '../data/dataTabLeson'

function TabLesson() {
    return (
        <div className="mb-5">
            <div className="d-flex justify-content-between align-items-start    ">
                <div className="d-flex">
                    <img src="https://via.placeholder.com/300x150" className="mr-3"/>
                    <div>
                        <p className="h4"><strong>Directional Branding</strong></p>
                        <p>Learn  to Attract Leads, Customers & Builders with Branding </p>
                    </div>
                </div>
                <div>
                    <p className="mb-0">Course Progress</p>
                    <ProgressBar animated now={45} className="rounded-pill my-1"/>
                    <p><strong className="h5">2/8</strong> Modules completed</p>
                </div>
            </div>
            <hr/>
            {dataTabLesson.map((data, idx) => (
                <div className="d-flex align-items-center justify-content-between border-bottom py-4" key={idx}>
                    <div className="d-flex align-items-center">
                        <Image src={data.cardImg} className="mr-3"/>
                        <p>{data.cardTitle}</p>
                    </div>
                    <div className="text-right">
                        {data.cardStatus == "completed" ? <><FaCheckCircle className="text-blue h5"/> <p>You've completed this</p></> : <> <strong>68%</strong> <p>You've watched this</p></> }
                    </div>
                </div>
            ))}
            
        </div>
    )
}

export default TabLesson
